<script setup lang="ts">
// COMPOSABLES
const route = useRoute();
const { apiOptions } = useStoryblokApiParams({ resolve_relations: 'storyblok-blog-post.categories' });

// GUARD
const slugString = Array.isArray(route.params.slug) ? route.params.slug.join('/') : route.params.slug;

if (slugString.startsWith('templates/')) {
    throw createError({ status: 404 });
}

// DATA
const { story, error } = await useStoryblokAsyncData(resolveStoryblokSlug(route.params.slug), {
    api: apiOptions,
    bridge: {},
});
useStoryblokProvideStoryMeta(story);

if (!story.value || error.value) {
    throw createError({ status: 404 });
}

// TRACKING
const { setStoryblokPageType } = useStoryblokTrackingPageType();
setStoryblokPageType(story.value.full_slug);

// SEO
useStoryblokSeoMeta(story);
</script>

<template>
    <StoryblokComponent v-if="story" :blok="story.content" />
</template>
